var icon = require('vue-svgicon')
icon.register({
  'ks-icon-plus': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M64 97.6A33.6 33.6 0 1 1 97.6 64 33.64 33.64 0 0 1 64 97.6M64 22a42 42 0 1 0 42 42 42 42 0 0 0-42-42m4.2 21h-8.4v16.8H43v8.4h16.8V85h8.4V68.2H85v-8.4H68.2z"/>'
  }
})
